export const environment = {
    siteId: 1,
    name: 'babylon',
    apiBaseUrl: 'https://api.lesdunes.es/api',
    baseUrl: 'https://api.lesdunes.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: 'u4?%t3IkV;@08r:e+W*,',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: false, // General switch for booking engine
    booking_engine_top_enabled: false, // Switch for booking engine button in top sliders
    booking_engine_extern: false,
    booking_button_engine_enabled: false, // Button booking engine
    openInNewWindow: false,
    trailingSlash: true,
    multipleMotorsModal: false,
    hotelRequestMotor: false, // Add request hotel motor
    normalizeUrlsToLowercase: false,
    minSizeMobileHeader: 768,
    menuComplexLinks: false,
    organizationName: 'Babylon',
    booking_engine_widget: true, // Use widget booking engine
    booking_engine_widget_dynamic: false, // widget static down
    dataBase: '../data/',
    sitesIndexFile: 'sites.json',
    fallbackUrl: 'https://www.lesdunes.es/',
    hideUserCentrics: false, //Only for dev on true
};
